export const MAX_BILLING_BALANCE = 375
export const CREDIT_COST = 0.75
export const ADDITIONAL_CREDIT_COST = 0.5
export const MAX_CREDITS = 500
export const MIN_CREDIT_COST = 0.5
